import {
  Button,
  HexIcon,
  Icons,
  Placeholder,
  tokens,
} from '@cast/design-system';

import { BuilderPanel } from './BuilderPanel';

type NoRulesPlaceholderProps = {
  disabled: boolean;
  onAddRule: () => void;
};

export const NoRulesPlaceholder = ({
  disabled,
  onAddRule,
}: NoRulesPlaceholderProps) => {
  return (
    <BuilderPanel>
      <Placeholder
        testId="evictor-no-rules-placeholder"
        title="Fine-tune eviction behavior"
        body="Protect or evict specific workloads and nodes"
        icon={
          <HexIcon
            icon={<Icons.MagnifyingGlass />}
            size={44}
            hexColor={tokens.primitives.colors.grey[300]}
            iconColor={tokens.primitives.colors.grey[400]}
          />
        }
        actions={
          <Button
            variant="secondary"
            size="sm"
            startIcon={<Icons.Plus />}
            disabled={disabled}
            onClick={onAddRule}
            testId="evictor-add-rule-button"
          >
            Add rule
          </Button>
        }
      />
    </BuilderPanel>
  );
};
